import { IntegrationBusFactory } from "@/Common/Modularity/IntegrationBus/IntegrationBusFactory";

/** Payload for the AppSessionExpiredEvent */
export type AppSessionExpiredPayload = { reason: "expired" | "logout" };
/** Public event emitted when the application session has expired or the user has logged out */
export const AppSessionExpiredEvent = IntegrationBusFactory.createEvent<AppSessionExpiredPayload>("AppSessionExpiredEvent");
